import * as React from 'react';
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {TabPanel} from "../../components/other/tabPanel";
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {useEffect} from "react";

import API from "../../app/api";
import {useDebounce} from "use-debounce";
import Paper from "@mui/material/Paper";
import Formatter from "../../util/formatter";
import MessageBox from "../../util/messageBox";
import {setSnackbar} from "../../store/reducers/globals";
import {useDispatch} from "react-redux";
import {styled} from "@mui/material/styles";

const useStyles = makeStyles((theme) => ({
    inputs: {
        display: "flex",
        " & > *": {
            marginRight: 20
        }
    },
    indicator: {
        backgroundColor: "#448FFF"
    }
}));

const StyledTab = styled(Tab)({
    "&.Mui-selected": {
        color:"#448FFF"
    }
})

const StyledTabs = styled(Tabs)({
    "&.MuiTabs-indicator": {
        backgroundColor:"#448FFF"
    }
})

class MergeRecord {
    from;
    to;
    date;
    source;
    id;
    unmerged;
    processed;
    message;
    action;
    documentsMerged;
    isMerging;

    constructor({unmerged, mergedFrom, patientId, lastModifiedDate, lastModifiedBy, __id, processed, message, documentsMerged}) {
        this.from = mergedFrom;
        this.to = patientId;
        this.date = lastModifiedDate;
        this.source = lastModifiedBy;
        this.id = __id;
        this.unmerged = unmerged;
        this.processed = processed;
        this.message = message;
        this.isMerging = false;
        if(this.processed && !this.unmerged) {
            this.action = "Merged";
        }else if(this.processed && this.unmerged) {
            this.action = "Unmerged";
        }else {
            this.action = "Error";
        }
        this.documentsMerged = documentsMerged;
    }

    canUnmerge(){
        if(this.isMerging) return false;
        if(this.unmerged || !this.processed) {
            return false;
        }
        if(this.toManualMerge && this.toManualMerge.length>0) {
            for (let toM of this.toManualMerge) {
                for (let mrgd of this.documentsMerged) {
                    if (mrgd === toM) {
                        return false;
                    }
                }
            }
        }
        return true;
    }


}

function PatientMerges(props) {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const dispatch = useDispatch();

    const [patients, setPatients] = React.useState({
        from: "",
        to: ""
    })

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handlePatientFrom = (e) => {
        setPatients((pr) => (
            {
                ...pr,
                from:  e.target.value
            }
        ));
    }
    const handlePatientTo = (e) => {
        setPatients((pr) => (
            {
                ...pr,
                to:  e.target.value
            }
        ));
    }

    const [patientsDebounced] = useDebounce(patients, 1000);
    const [mergeList, setMergeList] = React.useState(null);

    const getMergedPatientInfo = async (patientId) => {
        try {
            await API.getPatientInfo(patientId, controller.signal).then(patientFrom => {
                if(patientFrom.status !== 200){
                    dispatch(setSnackbar({type: "warring", message: `No data for given Patient ID: ${patientId}`}));
                    return null;
                }
                else {
                    return patientFrom
                }
            })
        }
        catch(err){
            console.error(err);
        }
    }


    const controller = new AbortController();

    useEffect(()=>{
        return () => {
            controller.abort();
        };
    }, [])

    const getMergeList = () => {
        if(patients.from || patients.to) {
            API.getMergesList(patients.from, patients.to, controller.signal).then(lists => {
                if(lists.__data) {
                    let mergeList = [];
                    lists.__data?.forEach((row) => {
                        mergeList.push(new MergeRecord(row));
                    })

                    setMergeList(mergeList);
                } else {
                    dispatch(setSnackbar({type: "warring", message: `No History of Merges/Unmerges`}));
                    setMergeList(null);
                }
                })
                .catch(err => {
                    console.error(err);

                })
                .finally(() => {

                });
        } else {
            setMergeList(null);
        }
    };


    useEffect(() => {
        getMergeList();
    }, [patientsDebounced])


    const mergePatientsConfirm = () =>{
        setConfirmModalData({
            title: "MERGE",
            message: `Are you sure that you want to merge ${patients.from} with ${patients.to}?`,
            onAccept: mergePatients,
            value: null
        })

        setConfirmDialog(true);
    }

    const mergePatients = async () => {
                let dataFrom = await API.getPatientInfo(patients.from, controller.signal)
                let dataTo = await API.getPatientInfo(patients.to, controller.signal)

                if (!dataFrom || !dataTo) {
                    setConfirmDialog(false);
                    return;
                };

                API.mergePatients(patients.from, patients.to, controller.signal).then(res => {
                    dispatch(setSnackbar({type: "success", message: `${patients.from} with ${patients.to} Merged`}));
                    getMergeList();
            })
            .catch(err => {
                dispatch(setSnackbar({type: "error", message: `Failed merged ${patients.from} with ${patients.to} `}));
                console.error(err);

            })
            .finally(() => {

            });
        setConfirmDialog(false);
    }


    const unmergePatientConfirm = (row) => {
        setConfirmModalData({
            title: "UNMERGE",
            message: `Are you sure that you want to unmerge ${row.from} with ${row.to}?`,
            onAccept: unmergePatient,
            value: row
        })

        setConfirmDialog(true);
    }

    const unmergePatient = (row) => {
        API.unmergePatient(row.id, controller.signal).then(res => {
                dispatch(setSnackbar({type: "success", message: `Success Unmerge ${row.from} with ${row.to} `}));
                getMergeList();
            })
            .catch(err => {
                dispatch(setSnackbar({type: "error", message: `Failed Unmerged ${row.from} with ${row.to} `}));
                console.error(err);

            })
            .finally(() => {

            });
        setConfirmDialog(false);
    }

    const columns = [
        { id: 'action', label: 'Info', minWidth: 170 },
        { id: 'date', label: 'Date', minWidth: 100, maxWidth: 225, format: (value) => {
                return Formatter.utcAndLocalFormatData(value,"YYYY-MM-DD HH:mm:ss", "");
            }},
        { id: 'source', label: 'Created by', minWidth: 170 },
        { id: 'from', label: 'From', minWidth: 100 },
        { id: 'to', label: 'To', minWidth: 100 },
        { id: 'act', actionList: [
                {   functionToCheck: 'canUnmerge',
                    callback: unmergePatientConfirm,
                    buttonLabel: "unmerge"
                }
            ], label: 'Actions', minWidth: 100 },

    ];

    const [confirmModalData, setConfirmModalData] = React.useState({
        title: "Confirmation",
        message: "message",
        onAccept: ()=>{},
        value: null

    })
    const [confirmDialog, setConfirmDialog] = React.useState(false);

    return (
        <Box sx={{ width: '100%' }}>
            <MessageBox
                onClose={() => setConfirmDialog(false)}
                title={confirmModalData.title}
                disableSave
                disabled={false}
                message={confirmModalData.message}
                haveAccept={{yes: 'Yes', no: 'No'}}
                onAccept={()=>confirmModalData.onAccept(confirmModalData.value)}
                open={confirmDialog}
            />
        <Box sx={{ borderBottom: 1, borderColor: 'divider'}}>
            <StyledTabs value={value} onChange={handleChange} aria-label="basic tabs example" TabIndicatorProps={{className: classes.indicator}}>
                <StyledTab label="Patient Merges"/>
            </StyledTabs>
        </Box>
        <TabPanel value={value} index={0}>
            <div className={classes.inputs}>
                <TextField id="outlined-basic"
                           label="Search for patient"
                           variant="outlined"
                           onChange={handlePatientFrom}
                           value={patients.from}
                />
                <TextField id="outlined-basic"
                           label="Merge with"
                           variant="outlined"
                           onChange={handlePatientTo}
                           value={patients.to}
                />
                <Button onClick={mergePatientsConfirm}
                        disabled={!(patients.to && patients.from)}
                        color={"primary"} variant="outlined" >
                    {"Merge"}
                </Button>

            </div>
                {mergeList &&
                    <div>
                        <Paper sx={{width: '100%', overflow: 'hidden'}}>
                        <TableContainer>
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id+"H"}
                                                align={column.align}
                                                style={{minWidth: column.minWidth, width: column.maxWidth}}
                                            >
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {mergeList
                                        .map((row) => {
                                            return (
                                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                                    {columns.map((column) => {
                                                        if(column.actionList) {
                                                            let buttons = [];
                                                            column.actionList.forEach((action)=>{
                                                                if(row[action.functionToCheck]())
                                                                    buttons.push( <Button key={action.buttonLabel}
                                                                                          onClick={() => action.callback(row)}>{action.buttonLabel}</Button>)
                                                            })

                                                            return (
                                                                <TableCell key={column.id} align={column.align}>
                                                                    {buttons}
                                                                </TableCell>
                                                            )
                                                        } else {
                                                            const value = row[column.id];
                                                            return (
                                                                <TableCell key={column.id} align={column.align}>
                                                                    {column.format
                                                                        ? column.format(value)
                                                                        : value}
                                                                </TableCell>
                                                            );
                                                        }

                                                    })}
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                    </div>
                }


        </TabPanel>
    </Box>)
}

export default PatientMerges;